// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___yzIFS","root__date":"style-module__root__date___qk4Fe","root__text":"style-module__root__text___O96LU","root__active":"style-module__root__active___ClPon","root__status":"style-module__root__status___zWXab"};
    if(module.hot) {
      // 1744730400672
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  